import { useState } from "react";
import { toast } from "sonner";
import { FileText, FileSpreadsheet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { download, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card, PageHeader, Spinner } from "@/components/Field";

const REPORTS = [
  { kind: "inventory", title: "Inventario", desc: "Prodotti, categorie, ubicazioni, quantità, lotti e scadenze", mod: "inventory" },
  { kind: "expiries", title: "Scadenze", desc: "Lotti scaduti e in scadenza nel mese corrente", mod: "inventory" },
  { kind: "movements", title: "Movimenti", desc: "Entrate, uscite e rettifiche con autore, destinatario e motivo", mod: "movements" },
  { kind: "shopping", title: "Lista della spesa", desc: "Articoli aperti, quantità, responsabili e stato", mod: "shopping" },
  { kind: "tasks", title: "Compiti", desc: "Titolo, responsabili, scadenza, stato ed evento", mod: "tasks" },
  { kind: "bookings", title: "Prenotazioni", desc: "Sala, data e orario, stato e dati per la gestione", mod: "bookings" },
];

export default function ReportsPage() {
  const { can } = useAuth();
  const [busy, setBusy] = useState(null);
  const get = async (kind, fmt) => {
    setBusy(`${kind}.${fmt}`);
    try {
      await download(`/exports/${kind}.${fmt}`, `${kind}_${new Date().toISOString().slice(0, 10)}.${fmt}`);
    } catch (e) {
      toast.error(formatError(e));
    } finally {
      setBusy(null);
    }
  };
  return (
    <>
      <PageHeader title="Report ed esportazioni" subtitle="I file sono generati al momento con i dati aggiornati e scaricati direttamente: nessun link pubblico." />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {REPORTS.filter((r) => can(r.mod, "view")).map((r) => (
          <Card key={r.kind} testId={`report-${r.kind}`} className="p-5 flex flex-col gap-3">
            <div><h2 className="font-heading text-lg font-semibold text-slate-900">{r.title}</h2><p className="text-sm text-slate-500">{r.desc}</p></div>
            <div className="flex gap-2 mt-auto">
              <Button data-testid={`report-${r.kind}-pdf`} className="h-11 flex-1" onClick={() => get(r.kind, "pdf")} disabled={!!busy}>{busy === `${r.kind}.pdf` ? <Spinner className="h-4 w-4" /> : <><FileText className="h-4 w-4 mr-1" /> PDF</>}</Button>
              <Button data-testid={`report-${r.kind}-csv`} variant="outline" className="h-11 flex-1" onClick={() => get(r.kind, "csv")} disabled={!!busy}>{busy === `${r.kind}.csv` ? <Spinner className="h-4 w-4" /> : <><FileSpreadsheet className="h-4 w-4 mr-1" /> CSV</>}</Button>
            </div>
          </Card>
        ))}
      </div>
    </>
  );
}
